var map = {
	"./sauce-noodles/sauce-noodles_01.mp4": 9843,
	"./sauce-noodles/sauce-noodles_02.mp4": 7257,
	"./sauce-noodles/sauce-noodles_03.mp4": 6684,
	"./sauce-noodles/sauce-noodles_04.mp4": 4387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8476;